<template>
  <div v-if="selectedCount > 0" class="batch-actions">
    <strong>已选择 {{ selectedCount }} 项</strong>
    <div v-if="!selectedFolderId" ref="moveDropdownRef" class="batch-move-dropdown">
      <button type="button" class="btn btn-sm" @click.stop="toggleMoveDropdown">
        批量移动
        <span class="batch-move-caret" aria-hidden="true">▾</span>
      </button>
      <div v-if="isMoveDropdownOpen" class="batch-move-menu" role="menu">
        <button
          v-for="folder in folders"
          :key="folder.id"
          type="button"
          class="batch-move-option"
          role="menuitem"
          @click="onMoveTo(folder.id)"
        >{{ folder.name }}</button>
        <p v-if="!folders.length" class="batch-move-empty">暂无文件夹，请先新建文件夹</p>
      </div>
    </div>
    <button v-else type="button" class="btn btn-sm" @click="$emit('move-out')">批量移出</button>
    <button v-if="canBatchDelete" type="button" class="btn btn-sm danger-outline" @click="$emit('delete')">批量删除</button>
    <button type="button" class="btn btn-sm" @click="$emit('clear')">取消选择</button>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

defineProps({
  selectedCount: {
    type: Number,
    default: 0,
  },
  folders: {
    type: Array,
    default: () => [],
  },
  selectedFolderId: {
    type: [String, Number, null],
    default: null,
  },
  canBatchDelete: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['move-to', 'move-out', 'delete', 'clear']);

const isMoveDropdownOpen = ref(false);
const moveDropdownRef = ref(null);

function toggleMoveDropdown() {
  isMoveDropdownOpen.value = !isMoveDropdownOpen.value;
}

function onMoveTo(folderId) {
  isMoveDropdownOpen.value = false;
  emit('move-to', folderId);
}

function handleGlobalClick(event) {
  if (moveDropdownRef.value && !moveDropdownRef.value.contains(event.target)) {
    isMoveDropdownOpen.value = false;
  }
}

onMounted(() => {
  window.addEventListener('click', handleGlobalClick);
});

onUnmounted(() => {
  window.removeEventListener('click', handleGlobalClick);
});
</script>

<style scoped>
.batch-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
}

.batch-actions strong {
  font-size: 12px;
  color: #6d28d9;
}

.batch-move-dropdown {
  position: relative;
}

.batch-move-caret {
  font-size: 10px;
  margin-left: 2px;
}

.batch-move-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 20;
  min-width: 168px;
  max-width: 240px;
  max-height: 240px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.14);
}

.batch-move-option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-dark, #0f172a);
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease;
}

.batch-move-option:hover {
  background: #f5f3ff;
  color: #6d28d9;
}

.batch-move-empty {
  margin: 0;
  padding: 8px 10px;
  color: var(--text-muted, #94a3b8);
  font-size: 12px;
  line-height: 1.5;
}

.btn-sm {
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid var(--border-color, #cbd5e1);
  background: #ffffff;
  color: var(--text-dark, #0f172a);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background 0.15s ease;
}

.btn-sm:hover {
  background: #f8fafc;
}

.btn-sm.danger-outline {
  border-color: #fecaca;
  color: #dc2626;
  background: #fff5f5;
}

.btn-sm.danger-outline:hover {
  background: #fee2e2;
}
</style>
